<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="loaded ? maintenances[0].room_object.model.category.name + (' Added' | translate) : ''"
    [noBow]="true"
    [canGoBack]="false" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <div [formGroup]="form">
    <ng-container formArrayName="maintenaceDates">
      <tidy-wrapper>


        @if (loaded) {
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-text
              [body]="'Please let us know when you last completed these maintenances on this item:'" />
          </tidy-row>
          @for (maintenaceDate of maintenaceDates.controls; track maintenaceDate; let i = $index) {
            <div [formGroup]="maintenaceDate" @fadeOut>
              <tidy-card>
                <tidy-row class="extra-bottom-padding">
                  <tidy-text
                    [header]="maintenances[i].maintenance?.name" />
                </tidy-row>
                @for (formValue of maintenances[i].formValues; track formValue) {
                  <tidy-row class="extra-bottom-padding">
                    <tidy-button
                      [action]="addItem.bind(this, maintenances[i], maintenaceDate, i, formValue.value)"
                      [text]="formValue.viewValue"
                      [smallText]="true"
                      class="no-padding secondary" />
                  </tidy-row>
                }
              </tidy-card>
            </div>
          }
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-text
              (action)="toMainCrudPage()"
              [body]="'Skip'"
              class="link" />
          </tidy-row>
        }

        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }

      </tidy-wrapper>
    </ng-container>
  </div>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
